import {CustomFieldValue, RaceAdditionalPricingItem, RaceCommercialItem} from "@model";
import dayjs from "dayjs";
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

export class CompetitorRegistrationDto {
  userId?: number;
  couponCode?: string;
  discountId?: number;
  customFieldValues?: Array<CustomFieldValue>;
  raceAdditionalPricingItems?: Array<RaceAdditionalPricingItem>;
  raceCommercialItem?: RaceCommercialItem;
  firstName?: string;
  lastName?: string;
  birthday?: string;
  placeOfResidence?: string;
  address?: string;
  city?: string;
  mobilePhone?: string;
  emergencyPhone?: string;
  identityCardNumber?: string;
  identityCardIssuer?: string;
  identityExpiration?: string;
  licence?: string;
  comment?: string;
  chipNumber?: string;
  bestTime?: string;
  club?: string;
  transport?: number;
  transportComment?: string;
  meal?: number;
  mealComment?: string;
  tShirt?: number;
  tshirtSizeComment?: string;
  email?: string;
  receiptEmail?: string;
  country?: string;
  nationality?: number;
  gender?: number;
  zip?: string;
  nickname?: string;
  receiveReceipt?: boolean;
  discipline?: number;
  teamName?: string;

  static dateToString(value: Date): string | undefined {
    if (value) {
      return dayjs(value).format("DD.MM.YYYY");
    } else {
      return undefined;
    }
  }

  static stringToDate(value: string): Date {
    return dayjs(value, 'DD.MM.YYYY').toDate();
  }
}

